import { render, staticRenderFns } from "./CompararTecnicos.vue?vue&type=template&id=376bb7cf&scoped=true"
import script from "./CompararTecnicos.vue?vue&type=script&lang=js"
export * from "./CompararTecnicos.vue?vue&type=script&lang=js"
import style0 from "./CompararTecnicos.vue?vue&type=style&index=0&id=376bb7cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376bb7cf",
  null
  
)

export default component.exports